var moduleMap = {
	"./ParticipantPortal": () => {
		return Promise.all([__webpack_require__.e(5655), __webpack_require__.e(220), __webpack_require__.e(4019), __webpack_require__.e(7244), __webpack_require__.e(9926), __webpack_require__.e(6585), __webpack_require__.e(2738), __webpack_require__.e(6114), __webpack_require__.e(4895), __webpack_require__.e(3154), __webpack_require__.e(4599)]).then(() => (() => ((__webpack_require__(34599)))));
	},
	"./components": () => {
		return Promise.all([__webpack_require__.e(9926), __webpack_require__.e(3579)]).then(() => (() => ((__webpack_require__(63579)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});